import Card from 'components/generic/card';
import RecommendationLoader from 'components/productRecommendation/components/RecommendationLoader';
import React from 'react';
import styled from 'styled-components';

const StyledRecommendationLoader = styled(RecommendationLoader)`
    && {
        padding: 0;
    }
`;

export default function BasketRecommendation() {
    return <RecommendationLoader model={{ $type: 'BasketRecommendationRequest' }} />;
}
